import { render, staticRenderFns } from "./YourInsuranceReports.vue?vue&type=template&id=637444c9&scoped=true&"
import script from "./YourInsuranceReports.vue?vue&type=script&lang=js&"
export * from "./YourInsuranceReports.vue?vue&type=script&lang=js&"
import style0 from "./YourInsuranceReports.vue?vue&type=style&index=0&id=637444c9&lang=scss&scoped=true&"
import style1 from "./YourInsuranceReports.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637444c9",
  null
  
)

export default component.exports